<template>
    <div id="reportDailySection">
        <card>
            <Form ref="searchForm" :model="searchForm" inline class="searchForm" id="searchFormSection" @keyup.enter.native="getDate()">
                <FormItem prop="date">
                    <DatePicker type="date" placeholder="选择日期"
                                format="yyyy-MM-dd" @on-change="searchForm.date=$event"
                                :value="searchForm.date" ></DatePicker>
                </FormItem>
                <Form-item prop="zoneId" label="校区" :label-width="60">
                    <Select v-model="searchForm.zoneId" filterable style="width: 250px" placeholder="全部" clearable>
                        <Option v-for="item in zoneList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                    </Select>
                </Form-item>
                <Form-item prop="teacherId" label="教师" :label-width="60">
                    <Select v-model="searchForm.teacherId" filterable style="width: 250px" clearable>
                        <Option v-for="item in teacherList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                    </Select>
                </Form-item>
                <FormItem>
                    <Button type="primary" @click="getDate"  size="small" style="margin-right:10px;">搜索</Button>
                    <Button type="primary" @click="exportDaily"  size="small">导出</Button>
                </FormItem>
            </Form>
            <h3 style="margin:10px 0">今日总完成课时数：{{total}},当月总完成课时数：{{monthTotal}}</h3>
            <Table :columns="columns" :data="data"></Table>
        </card>
    </div>
</template>
<script>
  import moment from 'moment';
  import config from '@/config'
  const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

  export default {
    name: 'report_daily',
    data () {
      return {
        total:0,
        monthTotal:0,
        searchForm:{
          date:moment(new Date()).format("YYYY-MM-DD"),
          zoneId:this.$store.state.app.zoneList[0].id,
          teacherId:null
        },
        columns: [
          {
            title: '序号',
            type: 'index'
          },
          {
            title: '教师',
            key: 'teacherName'
          },
          {
            title: '班级',
            key: 'className'
          },
          {
            title: '学员',
            key: 'studentName'
          },
          {
            title: '课时',
            key: 'num'
          }
        ],
        data: [],
      }
    },
    computed: {
      zoneList() {
        return this.$store.state.app.zoneList
      },
      teacherList() {
        return this.$store.state.app.teacherList
      },
    },
    methods: {
      getDate(){
        this.$api.report.daily({
          date:this.searchForm.date,
          zoneId:this.searchForm.zoneId,
          teacherId:this.searchForm.teacherId,
        }).then(resp => {
          this.data = resp.list;
          this.total = resp.total;
          this.monthTotal = resp.monthTotal;
        });
      },
      exportDaily(){
        window.open(baseUrl+"edu/web/report/exportdaily?date="
          +this.searchForm.date
          +"&zoneId="+this.searchForm.zoneId
          + (this.searchForm.teacherId?('&teacherId='+this.searchForm.teacherId):'') );
      }
    },
    mounted: function () {
      this.getDate();
    }
  }
</script>
